<template>
  <div>
    <div class="w-full text-center px-4 py-2 m-2 ml-auto mr-auto">
      <h1>{{ getText('selection_title') }}</h1>
      <p>{{ getText('selection_text')}}</p>
      <div class="ml-auto mr-auto flex justify-center" id="select">
        <div
          class="wide-box"
          :style="{ filter: isPlayingEasy || isPlayingMedium || isPlayingHard ? 'opacity(0.5)' : 'opacity(1)' }"
        >
          <div class="flex flex-auto flex-col justify-center">
            <div class="ml-auto mr-auto rounded-full icon-border">
              <img src="images/mic.svg" />
            </div>
            <div class="title">{{ getText('selection_my_yodeler') }}</div>
          </div>
          <button
            class="py-3 px-5 rounded-full w-full flex-end"
            @click="play('custom')"
            :disabled="isPlayingCustom"
            :class="{ 'opacity-50 cursor-not-allowed': isPlayingCustom }"
          >{{ getText("button_play") }}</button>
          <button
            class="py-3 px-5 rounded-full w-full mt-2 shadow-md select-my flex-end"
            @click="nextStep('custom')"
            :disabled="isCreatingVideo"
            :class="{ 'opacity-50 cursor-not-allowed': isCreatingVideo }"
          >{{ getText("button_select") }}</button>
        </div>
        <div
          class="box"
          :style="{ filter: isPlayingCustom || isPlayingMedium || isPlayingHard ? 'opacity(0.5)' : 'opacity(1)' }"
        >
          <div class="flex flex-auto flex-col justify-center">
            <div class="title">{{ getText('selection_pro_yodeler') }}</div>
            <div class="subtitle">{{ getText('difficulty_easy') }}</div>
          </div>
          <button
            class="py-3 px-5 rounded-full w-full flex-end"
            @click="play('pro_easy')"
            :disabled="isPlayingCustom"
            :class="{ 'opacity-50 cursor-not-allowed': isPlayingEasy }"
          >{{ getText("button_play") }}</button>
          <button
            class="py-3 px-5 rounded-full w-full mt-2 shadow-md select-pro flex-end"
            @click="nextStep('pro_easy')"
            :disabled="isCreatingVideo"
            :class="{ 'opacity-50 cursor-not-allowed': isCreatingVideo }"
          >{{ getText("button_select") }}</button>
        </div>
        <div
          class="box"
          :style="{ filter: isPlayingEasy || isPlayingCustom || isPlayingHard ? 'opacity(0.5)' : 'opacity(1)' }"
        >
          <div class="flex flex-auto flex-col justify-center">
            <div class="title">{{ getText('selection_pro_yodeler') }}</div>
            <div class="subtitle">{{ getText('difficulty_medium') }}</div>
          </div>
          <button
            class="py-3 px-5 rounded-full w-full flex-end"
            @click="play('pro_medium')"
            :disabled="isPlayingCustom"
            :class="{ 'opacity-50 cursor-not-allowed': isPlayingMedium }"
          >{{ getText("button_play") }}</button>
          <button
            class="py-3 px-5 rounded-full w-full mt-2 shadow-md select-pro flex-end"
            @click="nextStep('pro_medium')"
            :disabled="isCreatingVideo"
            :class="{ 'opacity-50 cursor-not-allowed': isCreatingVideo }"
          >{{ getText("button_select") }}</button>
        </div>
        <div
          class="box"
          :style="{ filter: isPlayingEasy || isPlayingMedium || isPlayingCustom ? 'opacity(0.5)' : 'opacity(1)' }"
        >
          <div class="flex flex-auto flex-col justify-center">
            <div class="title">{{ getText('selection_pro_yodeler') }}</div>
            <div class="subtitle">{{ getText('difficulty_hard') }}</div>
          </div>
          <button
            class="py-3 px-5 rounded-full w-full flex-end"
            @click="play('pro_hard')"
            :disabled="isPlayingCustom"
            :class="{ 'opacity-50 cursor-not-allowed': isPlayingHard }"
          >{{ getText("button_play") }}</button>
          <button
            class="py-3 px-5 rounded-full w-full mt-2 shadow-md select-pro flex-end"
            @click="nextStep('pro_hard')"
            :disabled="isCreatingVideo"
            :class="{ 'opacity-50 cursor-not-allowed': isCreatingVideo }"
          >{{ getText("button_select") }}</button>
        </div>
      </div>
    </div>

    <audio id="selectAudio">
      <source src="sounds/easy_F.mp3" type="audio/mp3" />
    </audio>
  </div>
</template>

<style scoped>
h1 {
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  text-transform: uppercase;
  width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 22px;
  text-align: center;
}

p {
  font-family: FoundryWilsonNormal;
  font-size: 28px;
  letter-spacing: 1px;
  width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 22px;
  text-align: center;
}

button {
  font-size: 20px !important;
  color: #544b45 !important;
  border: 3px solid #544b45 !important;
}

button.select-my {
  color: white !important;
  background-color: #544b45 !important;
  border: none !important;
}

button.select-pro {
  color: #544b45 !important;
  background-color: white !important;
  border: none !important;
}

.icon-border {
  border: 3px solid #544b45;
  padding: 20px 30px;
}

#select {
  margin-top: 26px;
}

.wide-box {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 20px;
  border-radius: 30px;
  color: #544b45;
  width: 690px;
  height: 696px;
  margin: 20px;
}

.box {
  background-color: #e4e1db;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 20px;
  border-radius: 30px;
  color: #544b45;
  width: 260px;
  height: 696px;
  margin: 20px;
}

.title {
  text-transform: uppercase;
  font-size: 36px;
  text-align: center;
}

.box .subtitle {
  font-family: FoundryWilsonItalic;
  font-size: 31px;
}

.box .difficulty {
  display: flex;
  justify-content: center;
  margin-top: 110px;
}

.box .difficulty img {
  width: 80px;
  margin: 5px;
}
</style>

<script>
import axios from "axios";

export default {
  name: "Selection",

  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },

    play(which) {
      let src = null;
      switch (which) {
        case "custom":
          src = this.$variables.recording;
          this.isPlayingCustom = true;
          break;
        case "pro_easy":
          src = "sounds/easy_" + this.$variables.gender + ".mp3";
          this.isPlayingEasy = true;
          break;
        case "pro_medium":
          src = "sounds/medium_" + this.$variables.gender + ".mp3";
          this.isPlayingMedium = true;
          break;
        case "pro_hard":
          src = "sounds/hard_" + this.$variables.gender + ".mp3";
          this.isPlayingHard = true;
          break;
      }
      let audio = document.getElementById("selectAudio");
      audio.src = src;
      audio.play();
      audio.addEventListener("ended", () => {
        this.isPlayingCustom = false;
        this.isPlayingEasy = false;
        this.isPlayingMedium = false;
        this.isPlayingHard = false;
      });
    },

    previousStep() {
      this.$router.push("/photo/" + this.$route.params.lang);
    },

    nextStep(which) {
      this.isCreatingVideo = true;
      switch (which) {
        case "custom":
          fetch(this.$variables.recording).then(
            r => r.blob().then(r => this.createVideo(r))
          );
          break;
        case "pro_easy":
          fetch(
            "sounds/easy_" + this.$variables.gender + ".mp3"
          ).then(r => r.blob().then(r => this.createVideo(r)));
          break;
        case "pro_medium":
          fetch(
            "sounds/medium_" + this.$variables.gender + ".mp3"
          ).then(r => r.blob().then(r => this.createVideo(r)));
          break;
        case "pro_hard":
          fetch(
            "sounds/hard_" + this.$variables.gender + ".mp3"
          ).then(r => r.blob().then(r => this.createVideo(r)));
          break;
      }
    },

    createVideo(audioBlob) {
      let data = new FormData();
      this.b64toBlob(
        this.$variables.photoBase64,
        "image/jpeg"
      ).then(imageBlob => {
        data.append("image", imageBlob, "image.jpg");
        data.append("audioFile", audioBlob, "audio.webm");
        let config = {
          header: {
            "Content-Type": "multipart/form-data"
          }
        };
        axios
          .post(
            `${process.env.VUE_APP_VIDEO_SERVICE_URL}api/Video/create`,
            data,
            config
          )
          .then(response => {
            this.$variables.videoPath = response.data;
            this.$router.push("/email/" + this.$route.params.lang);
            this.isCreatingVideo = false;
          });
      });
    },

    b64toBlob(base64, type = "application/octet-stream") {
      return fetch(`data:${type};base64,${base64}`).then(res => res.blob());
    }
  },

  data() {
    return {
      isPlayingCustom: false,
      isPlayingEasy: false,
      isPlayingMedium: false,
      isPlayingHard: false,
      isCreatingVideo: false,
      previewImage: null
    };
  },

  mounted() {},

  beforeDestroy() {}
};
</script>